import { Container, Graphics, Text } from 'pixi.js';
import { WORLD_W, WORLD_H, palette } from '../render/theme.js';
import { audioBus } from '../audio/audio.js';

export class TitleScreen {
  readonly container: Container;
  private onStart: (() => void) | null = null;

  constructor() {
    this.container = new Container();
    this.build();
  }

  private build(): void {
    const c = this.container;

    // Dark overlay
    const bg = new Graphics();
    bg.rect(0, 0, WORLD_W, WORLD_H).fill({ color: 0x050810, alpha: 0.95 });
    c.addChild(bg);

    // Decorative lines
    const deco = new Graphics();
    deco.moveTo(0, WORLD_H * 0.35).lineTo(WORLD_W, WORLD_H * 0.35)
      .stroke({ color: palette.playerFill, width: 1, alpha: 0.3 });
    deco.moveTo(0, WORLD_H * 0.65).lineTo(WORLD_W, WORLD_H * 0.65)
      .stroke({ color: palette.playerFill, width: 1, alpha: 0.3 });
    c.addChild(deco);

    // Title
    const title = new Text({
      text: 'NEBULARK',
      style: {
        fill: palette.playerFill,
        fontSize: 52,
        fontFamily: 'monospace',
        fontWeight: 'bold',
        letterSpacing: 6,
      },
    });
    title.anchor.set(0.5, 0.5);
    title.x = WORLD_W / 2;
    title.y = WORLD_H * 0.38;
    c.addChild(title);

    // Subtitle
    const sub = new Text({
      text: 'TOP-DOWN SHOOTER',
      style: {
        fill: 0x6688aa,
        fontSize: 14,
        fontFamily: 'monospace',
        letterSpacing: 3,
      },
    });
    sub.anchor.set(0.5, 0.5);
    sub.x = WORLD_W / 2;
    sub.y = WORLD_H * 0.46;
    c.addChild(sub);

    // Tap to start
    const tap = new Text({
      text: 'TAP TO START',
      style: {
        fill: 0xffffff,
        fontSize: 18,
        fontFamily: 'monospace',
        letterSpacing: 4,
      },
    });
    tap.anchor.set(0.5, 0.5);
    tap.x = WORLD_W / 2;
    tap.y = WORLD_H * 0.62;
    c.addChild(tap);

    // Blink tap text
    let t = 0;
    this.container.on('added', () => {
      const ticker = (dt: { deltaMS: number }) => {
        t += dt.deltaMS;
        tap.alpha = 0.5 + 0.5 * Math.sin(t / 400);
      };
      this.container.on('destroyed', () => {
        // nothing
      });
      // Attach ticker via parent app — we'll do it by polling ageMs in main
      void ticker;
    });

    // Controls hint
    const hint = new Text({
      text: 'DRAG TO MOVE  •  TAP BOMB TO DETONATE',
      style: {
        fill: 0x445566,
        fontSize: 10,
        fontFamily: 'monospace',
        letterSpacing: 1,
      },
    });
    hint.anchor.set(0.5, 0.5);
    hint.x = WORLD_W / 2;
    hint.y = WORLD_H * 0.75;
    c.addChild(hint);

    // Listen for tap
    this.container.interactive = true;
    this.container.hitArea = { contains: () => true } as unknown as import('pixi.js').Rectangle;
    this.container.on('pointerdown', () => {
      audioBus.unlock();
      this.onStart?.();
    });
  }

  onStartGame(cb: () => void): void {
    this.onStart = cb;
  }

  update(_dtMs: number): void {
    // Simple blink on tap text (find it by child index 4)
    const tap = this.container.children[4] as Text | undefined;
    if (tap) {
      tap.alpha = 0.5 + 0.5 * Math.sin(performance.now() / 400);
    }
  }
}
